import { axios } from "lib/axios";
import { useQuery } from "react-query";

export const getEvents = () => {
  return axios.get("/events");
};

export const useEvents = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["events"],
    queryFn: () => getEvents(),
  });
};
